import React from 'react'
import { Link } from 'react-router-dom'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { linkStyle } from "./linkStyle";

export default function Sponsorlar()
{
    const sponsorMenu = [
        { name: "Ana Sponsorlar", url: "/anasponsorlar", blank: "/" },
        { name: "Altın Sponsorlar", url: "/altinsponsorlar", blank: "/" },
        { name: "Gümüş Sponsorlar", url: "/gumussponsorlar", blank: "/" },
        { name: "Bronz Sponsorlar", url: "/bronzsponsorlar", blank: "/" }
    ];

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                Sponsorlar
            </DropdownToggle>
            <DropdownMenu right>
                {
                    sponsorMenu.map((item, index) => (
                        <DropdownItem>
                            <Link to={item.url}>{item.name}</Link>
                        </DropdownItem>
                    ))
                }
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}
